import { Injectable } from '@angular/core';
import {
  PatientWorkflow,
  PatientWorkflowApiService,
} from '@frontend/shared/patient-workflow/data-access/src';
import { PatientApiService } from '@frontend/shared/patient/data-access/src';
import { TagApiService } from '@frontend/shared/tag/data-access/src/lib/tag-api/tag-api.service';
import { forkJoin, of } from 'rxjs';
import { concatMap, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CheckInKioskFeatureCheckOutService {
  constructor(
    private tagService: TagApiService,
    private patientService: PatientApiService,
    private patientWorkflowService: PatientWorkflowApiService
  ) {}

  checkOut(tagValue, workflow_id) {
    const getTagByValue = (label) =>
      this.tagService.get({ label }).pipe(
        map((tags: any[]) => (tags)[0]),
        tap((tag) => {
          if (!tag) {
            throw { errorCode: 'TAG_NOT_FOUND' };
          }
        })
      );
    const getPatientByTag = (tag) =>
      this.patientService.get({ tag_id: tag.id }).pipe(
        map((patients: any[]) => (patients)[0]),
        tap((patient) => {
          if (!patient) {
            throw { errorCode: 'PATIENT_NOT_FOUND' };
          }
        })
      );
    const getPatientWorkflowsByPatient = (patient) =>
      this.patientWorkflowService.get({ patient_department_visit_id: patient.id });
    const completePatientWorkflows = (pws) => {
      if (!pws.length) {
        return of(null);
      }
      return forkJoin(pws.map((pw) => this.patientWorkflowService.complete(pw.id)));
    };
    return getTagByValue(tagValue).pipe(
      concatMap(getPatientByTag),
      concatMap((patient: any) =>
        getPatientWorkflowsByPatient(patient).pipe(
          concatMap(completePatientWorkflows),
          concatMap(() =>
            this.patientWorkflowService.create({
              patient_department_visit_id: patient.id,
              workflow_id,
            } as PatientWorkflow)
          )
        )
      )
    );
  }
}
